import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicEnvironmentService {
  apiServicesUrl: string = '';

  constructor() {
  }
}
